import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  websiteInfoCard: {
    padding: "15px 15px 15px 30px",
    position: "sticky",
    top: 0,
    zIndex: 10,
    backgroundColor: "white",
  },
  spaceContainer: {
    display: "flex",
    justifyContent: "space-between",
  },
  setupChecklistCard: {
    borderLeft: `1px solid ${theme.palette.customColor.LINE}`,
  },
  badge: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    padding: "6px 12px",
    borderRadius: "4px",
    marginBottom: "16px",
  },
  badgeText: {
    color: "#050505 !important",
  },
  infoSection: {
    marginBottom: "16px",
  },
  domainLink: {
    color: "#4B9EF9 !important",
    cursor: "pointer",
  },
  progressContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 25px",
  },
  progressText: {
    display: "flex",
    gap: "10px",
    width: "35%",
    alignItems: "center",
  },
  progressBar: {
    width: "100%",
  },
  checklistItem: {
    display: "flex",
    alignItems: "center",
    padding: "15px 20px",
    borderBottom: `1px solid ${theme.palette.customColor.LINE}`,
    gap: "10px",
  },
  checkmarkDone: {
    color: theme.palette.success.main,
  },
  checkmarkTodo: {
    color: theme.palette.error.main,
  },
  checklistLabel: {
    flex: 1,
  },
  emptyStateCard: {
    padding: "40px 20px",
    textAlign: "center",
  },
  createIconContainer: {
    marginBottom: "24px",
  },
  emptyStateSubheading: {
    marginBottom: "8px",
  },
  emptyStateTextContainer: {
    marginBottom: "20px",
  },
  dotIcon: {
    fontSize: "11px !important",
  },
}));
